export default __webpack_public_path__ + "static/media/smartops.e8992c22.png";